import { render, staticRenderFns } from "./ProjectDeliverables.vue?vue&type=template&id=29b5527b&scoped=true"
import script from "./ProjectDeliverables.vue?vue&type=script&lang=js"
export * from "./ProjectDeliverables.vue?vue&type=script&lang=js"
import style0 from "./ProjectDeliverables.vue?vue&type=style&index=0&id=29b5527b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b5527b",
  null
  
)

export default component.exports